// import user from '../assets/60111.jpg';

// const images = {
//     user : user,
// }

// export default images;

import user from '../assets/user.png';
const images = {
    user : user,
}
export default images;

//in the required folder fetch the images by images.user and so on